import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Form, Spinner, Badge, Tabs, Tab } from "react-bootstrap";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";
import { Ciclo, Peca, Valvulas } from "./Types";
import { Laptop, Lock } from "@mui/icons-material";
import ModalAcompanhamentoACV from "./ModalAcompanhamentoACV";
import ModalControleValvulasFechadas from "./ModalControleValvulasFechadas";

export const TabelaApontametosACV = ({ atualizarSignal }: { atualizarSignal?: number }) => {

  const [ciclos, setCiclos] = useState<Ciclo[]>([]);
  const [pecasPorCiclo, setPecasPorCiclo] = useState<Record<number, Peca[]>>({});
  const [contagemPecas, setContagemPecas] = useState<Record<number, number>>({});
  const [contagemSets, setContagemSets] = useState<Record<number, number>>({});
  const [loadingCiclos, setLoadingCiclos] = useState<boolean>(false);
  const [loadingPecas, setLoadingPecas] = useState<boolean>(false);
  const [searchOrdem, setSearchOrdem] = useState<string>("");
  const [abaAtiva, setAbaAtiva] = useState<string>("aguardando");

  const [peca, setPeca] = useState<Peca>({
    ordem: "",
    posicao: "",
    piso: null,
    tipoPeca: "",
    codigoVeiculo: "",
    projeto: "",
    veiculo: "",
    matricula: "",
    ordem_CC_RetMin: 0
  });

  const [ordens, setOrdens] = useState<string[]>(["", "", "", "", ""]);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([null, null, null, null, null]);

  const [cicloSelecionado, setCicloSelecionado] = useState<number | null>(null);
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [modal, setModal] = useState(false);

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const [showConfirmApontamento, setShowConfirmApontamento] = useState(false);
  const [cicloParaApontar, setCicloParaApontar] = useState<Ciclo | null>(null);
  const [loadingApontamento, setLoadingApontamento] = useState(false);
  const [matriculaApontamento, setMatriculaApontamento] = useState<string>("");

  const [modalChecklistACV, setModalChecklistACV] = useState(false);
  const [showEditAutoclave, setShowEditAutoclave] = useState(false);
  const [editingCiclo, setEditingCiclo] = useState<Ciclo | null>(null);
  const [editingCyclo, setEditingCyclo] = useState<string>("");
  const [editingAutoclave, setEditingAutoclave] = useState<string>("");
  const [editingCarro, setEditingCarro] = useState<string>("");
  const [loadingEditAutoclave, setLoadingEditAutoclave] = useState(false);
  const [cicloSelecionando, setCicloSelecionando] = useState<Ciclo | null>(null);

  const [valvulasFechadas, setValvulasFechadas] = useState<Valvulas[]>([]);
  const [cicloValvulas, setCicloValvulas] = useState(null);
  const [showModalListaValvulas, setShowModalListaValvulas] = useState(false);
  const [showModalCriarValvula, setShowModalCriarValvula] = useState(false);

  const operadores: { matricula: string; nome: string }[] = [
    { matricula: "3398", nome: "EDERSON SCHEIBLER" },
    { matricula: "3264", nome: "MATHEUS GUSTAVO FERREIRA ANACLETO" },
    { matricula: "3591", nome: "CLEBERSON PADILHA DA SILVA" },
    { matricula: "2030", nome: "SAMUEL SOUZA DA SILVA" },
    { matricula: "3428", nome: "MARCOS VINICIUS MOURA FERREIRA" },
    { matricula: "3493", nome: "GUILHERME HENRIQUE DA CONCEICAO RIBEIRO" },
    { matricula: "3188", nome: "NIVALDO LORENTE GALVAO" },
    { matricula: "3169", nome: "MATEUS DA VEIGA DIAS" },
    { matricula: "2508", nome: "KARINA TORRES DA SILVA SANTOS" },
    { matricula: "2363", nome: "ALBERTO OBERST JUNIOR" },
    { matricula: "2771", nome: "ALEXANDRE MOREIRA DE SOUZA" },
    { matricula: "1321", nome: "RODRIGO DE LIMA DOS REIS" },
  ];

  const carrosPorAutoclave: Record<string, string[]> = {
    Chicago: ["Chicago - 1", "Chicago - 2", "Chicago - 3"],
    "Matriz Molde": ["Matriz - 1", "Matriz - 2"],
    Ferlex: ["Ferlex - 1", "Ferlex - 2"],
    Fhaizer: ["Fhaizer - 1", "Fhaizer - 2"],
  };

  const carrosDisponiveis = carrosPorAutoclave[editingAutoclave] || [];

  // ── Helpers ──────────────────────────────────────────────────────────────

  const calcularQuantidadeSets = (valor: number): number => valor / 4.5;

  const calcularTotalSets = (pecas: Peca[]): number =>
    pecas.reduce((total, p) => total + calcularQuantidadeSets(p.ordem_CC_RetMin || 0), 0);

  const groupByAutoclave = (lista: Ciclo[]): Record<string, Ciclo[]> =>
    lista.reduce((acc, ciclo) => {
      const key = ciclo.autoclave || "Outras";
      if (!acc[key]) acc[key] = [];
      acc[key].push(ciclo);
      return acc;
    }, {} as Record<string, Ciclo[]>);

  const resumoPorTipo = (pecas: Peca[]): Record<string, number> =>
    pecas.reduce((acc, p) => {
      if (!p.tipoPeca) return acc;
      acc[p.tipoPeca] = (acc[p.tipoPeca] || 0) + 1;
      return acc;
    }, {} as Record<string, number>);

  const getStatusClass = (status: string) => {
    const s = status?.toLowerCase() ?? "";
    if (s.includes("aguardando")) return "bg-warning text-dark";
    if (s.includes("em ciclo")) return "bg-primary text-white";
    if (s.includes("saida") || s.includes("saída")) return "bg-success text-white";
    return "bg-secondary text-white";
  };

  // ── API calls ─────────────────────────────────────────────────────────────

  const handelOpenACVCloseModalCheckList = async (cicloKey: number) => {
    const ciclo = ciclos.find(c => c.ciclo_key === cicloKey) || null;
    setCicloSelecionando(ciclo);
    setModalChecklistACV(true);
  };

  const abrirEditarAutoclave = (ciclo: Ciclo) => {
    setEditingCiclo(ciclo);
    setEditingCyclo(ciclo.ciclo ?? "");
    setEditingAutoclave(ciclo.autoclave ?? "");
    setEditingCarro(ciclo.carro ?? "");
    setShowEditAutoclave(true);
  };

  const salvarAutoclave = async () => {
    if (!editingCiclo) return;
    setLoadingEditAutoclave(true);
    try {
      await blogFetch.put("ApontamentoAutoClave/updateAutoclave", {
        ciclo_key: editingCiclo.ciclo_key,
        ciclo: editingCyclo,
        autoclave: editingAutoclave,
        carro: editingCarro,
      });
      toast.success("Autoclave atualizada com sucesso!");
      setShowEditAutoclave(false);
      setEditingCiclo(null);
      carregarCiclos();
    } catch (error: any) {
      console.error("Erro ao atualizar autoclave:", error);
      toast.error(error.response?.data || "Erro ao atualizar autoclave.");
    } finally {
      setLoadingEditAutoclave(false);
    }
  };

  const carregarCiclos = async () => {
    setLoadingCiclos(true);
    try {
      const { data } = await blogFetch.get("ApontamentoAutoClave/GetCiclos");
      if (Array.isArray(data)) {
        setCiclos(data);
        carregarContagemTodasPecas(data);
      } else {
        setCiclos([]);
        console.warn("Dados de ciclos inválidos:", data);
      }
    } catch (error: any) {
      console.error("Erro ao carregar ciclos:", error);
      toast.error(error.response?.data || "Erro ao carregar ciclos.");
      setCiclos([]);
    } finally {
      setLoadingCiclos(false);
    }
  };

  const buscarPecaData = async (ordem: string) => {
    try {
      const { data } = await blogFetch.get(`ApontamentoAutoClave/getPeca/${ordem}`);
      if (!data) return null;
      return {
        tipoPeca: data.ordem_Part_Short || "",
        codigoVeiculo: data.ordem_VehCod || "",
        projeto: data.subProduto_Desc || "",
        veiculo: data.ordem_VehDesc || "",
        ordem_CC_RetMin: data.ordem_CC_RetMin || 0,
      };
    } catch {
      return null;
    }
  };

  const carregarContagemTodasPecas = async (ciclosData: Ciclo[]) => {
    const novaContagem: Record<number, number> = {};
    const novaContagemSets: Record<number, number> = {};
    const novasPecas: Record<number, Peca[]> = {};

    for (const ciclo of ciclosData) {
      try {
        const { data } = await blogFetch.get(`ApontamentoAutoClave/getPecasByCiclo/${ciclo.ciclo_key}`);
        if (Array.isArray(data)) {
          novaContagem[ciclo.ciclo_key] = data.length;
          novaContagemSets[ciclo.ciclo_key] = calcularTotalSets(data);
          novasPecas[ciclo.ciclo_key] = data;
        } else {
          novaContagem[ciclo.ciclo_key] = 0;
          novaContagemSets[ciclo.ciclo_key] = 0;
          novasPecas[ciclo.ciclo_key] = [];
        }
      } catch {
        novaContagem[ciclo.ciclo_key] = 0;
        novaContagemSets[ciclo.ciclo_key] = 0;
        novasPecas[ciclo.ciclo_key] = [];
      }
    }

    setContagemPecas(novaContagem);
    setContagemSets(novaContagemSets);
    setPecasPorCiclo(novasPecas);
  };

  useEffect(() => {
    carregarCiclos();
  }, [atualizarSignal]);


  const carregarPecasDoCiclo = async (cicloKey: number) => {
    setLoadingPecas(true);
    try {
      const { data } = await blogFetch.get(`ApontamentoAutoClave/getPecasByCiclo/${cicloKey}`);
      if (Array.isArray(data)) {
        setPecasPorCiclo((prev) => ({ ...prev, [cicloKey]: data }));
        setContagemPecas((prev) => ({ ...prev, [cicloKey]: data.length }));
        setContagemSets((prev) => ({ ...prev, [cicloKey]: calcularTotalSets(data) }));
      } else {
        setPecasPorCiclo((prev) => ({ ...prev, [cicloKey]: [] }));
        setContagemPecas((prev) => ({ ...prev, [cicloKey]: 0 }));
        setContagemSets((prev) => ({ ...prev, [cicloKey]: 0 }));
      }
    } catch (error: any) {
      console.error("Erro ao buscar peças do ciclo:", error);
      toast.error(error.response?.data || "Erro ao buscar peças do ciclo.");
    } finally {
      setLoadingPecas(false);
    }
  };

  const imprimirEtiqueta = (ordem: string) => {
    const link = document.createElement('a');
    link.href = `sagaprintserver:BR-EntradaAutoclave;SAGA_User;${ordem}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const adicionarPecaPorIndex = async (ordem: string, index: number, printLabel = true): Promise<boolean> => {
    if (!cicloSelecionado) { toast.error("Selecione um ciclo."); return false; }
    if (!ordem.trim()) return false;
    if (!peca.posicao.trim()) { toast.error("Selecione a posição."); return false; }

    try {
      const info = await buscarPecaData(ordem.trim());
      await blogFetch.post("ApontamentoAutoClave/addPeca", {
        ordem: ordem.trim(),
        posicao: peca.posicao,
        piso: peca.piso?.toString(),
        ciclo: cicloSelecionado,
        tipoPeca: info?.tipoPeca ?? "",
        codigoVeiculo: info?.codigoVeiculo ?? "",
        projeto: info?.projeto ?? "",
        veiculo: info?.veiculo ?? "",
        matricula: peca.matricula || null,
        ordem_CC_RetMin: info?.ordem_CC_RetMin ?? null,
      });
      toast.success(`Peça ${ordem.trim()} adicionada!`);
      if (printLabel) imprimirEtiqueta(ordem.trim());
      setOrdens(prev => prev.map((o, i) => i === index ? "" : o));
      await carregarPecasDoCiclo(cicloSelecionado);
      if (index < 4) setTimeout(() => inputRefs.current[index + 1]?.focus(), 50);
      return true;
    } catch (error: any) {
      toast.error(error.response?.data || "Erro ao adicionar peça.");
      return false;
    }
  };

  const adicionarTodas = async () => {
    for (let i = 0; i < ordens.length; i++) {
      if (ordens[i].trim()) {
        await adicionarPecaPorIndex(ordens[i], i, true);
      }
    }
  };

  const handleACVCloseModalCheckList = () => {
    setModalChecklistACV(false);
  };

  const handleRetiraPeca = async (ordem: string) => {
    if (!ordem) {
      toast.error("Algo deu errado. Ordem da peça não encontrada.");
      return;
    }
    try {
      await blogFetch.delete(`ApontamentoAutoClave/removePeca/${ordem}`);
      toast.success("Peça retirada com sucesso!");
      if (expandedRow) {
        await carregarPecasDoCiclo(expandedRow);
      }
    } catch (error: any) {
      console.error("Erro ao retirar peça:", error);
      toast.error(error.response?.data || "Erro ao retirar peça.");
    }
  };

  const RemoverCiclo = async (cicloKey: number) => {
    if (!cicloKey) {
      toast.error("Algo deu errado. Ciclo não encontrado.");
      return;
    }
    try {
      await blogFetch.delete(`ApontamentoAutoClave/removeCiclo/${cicloKey}`);
      toast.success("Ciclo excluído com sucesso!");
      carregarCiclos();
    } catch (error: any) {
      console.error("Erro ao excluir ciclo:", error);
      toast.error(error.response?.data || "Erro ao excluir ciclo.");
    }
  };

  const abrirListaValvulas = (e: any, ciclo: any) => {
    e.stopPropagation();
    setCicloValvulas(ciclo);
    setShowModalListaValvulas(true);
    carregarValvulas(ciclo.ciclo_isaga);
  };

  const carregarValvulas = async (cicloKey: string | undefined) => {
    try {
      setValvulasFechadas([]);
      const resp = await blogFetch.get(`/ISAGA_ValvulasFechadas/listar_valvulas/${cicloKey}`);
      setValvulasFechadas(resp.data || []);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar válvulas fechadas!");
    }
  };

  // Apontamento com matrícula SAP coletada no momento do apontamento
  const handleConfirmApontamento = async () => {
    if (!cicloParaApontar) return;
    if (matriculaApontamento.trim().length < 6) {
      toast.error("Informe a matrícula SAP (mínimo 6 caracteres).");
      return;
    }
    setLoadingApontamento(true);
    try {
      await blogFetch.put("ApontamentoAutoClave/apontarCiclo", {
        ciclo: cicloParaApontar.ciclo_isaga,
        user: user.user_UserName,
        matricula: matriculaApontamento.trim(),
      });
      toast.success("Apontamento realizado com sucesso!");
      fecharModalApontamento();
      carregarCiclos();
    } catch (error: any) {
      console.error(error);
      toast.error(error.response?.data || "Erro ao apontar ciclo.");
    } finally {
      setLoadingApontamento(false);
    }
  };

  const resetarPeca = () => {
    setPeca({
      ordem: "",
      posicao: "",
      piso: null,
      tipoPeca: "",
      codigoVeiculo: "",
      projeto: "",
      veiculo: "",
      matricula: "",
      ordem_CC_RetMin: 0
    });
    setOrdens(["", "", "", "", ""]);
  };

  useEffect(() => {
    if (modal) {
      const timer = setTimeout(() => {
        inputRefs.current[0]?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [modal]);

  const fecharModal = () => {
    setModal(false);
    setCicloSelecionado(null);
    resetarPeca();
  };

  const fecharModalApontamento = () => {
    setShowConfirmApontamento(false);
    setMatriculaApontamento("");
  };

  const toggleRow = async (id: number) => {
    if (expandedRow === id) {
      setExpandedRow(null);
      return;
    }
    setExpandedRow(id);
    await carregarPecasDoCiclo(id);
  };

  // ── Teclado ───────────────────────────────────────────────────────────────

  const posicoes = ["Fundo", "Centro", "Porta"];
  const pisos = Array.from({ length: 8 }, (_, i) => i + 1);

  // Setas navegam entre botões de posição; Enter seleciona
  const handlePosicaoKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>, idx: number) => {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      (e.currentTarget.parentElement?.children[(idx + 1) % posicoes.length] as HTMLButtonElement)?.focus();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      (e.currentTarget.parentElement?.children[(idx - 1 + posicoes.length) % posicoes.length] as HTMLButtonElement)?.focus();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      setPeca(p => ({ ...p, posicao: posicoes[idx].toLowerCase() }));
    }
  };

  // Setas navegam entre botões de piso; Enter seleciona
  const handlePisoKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>, idx: number) => {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      (e.currentTarget.parentElement?.children[(idx + 1) % pisos.length] as HTMLButtonElement)?.focus();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      (e.currentTarget.parentElement?.children[(idx - 1 + pisos.length) % pisos.length] as HTMLButtonElement)?.focus();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      setPeca(p => ({ ...p, piso: pisos[idx] }));
    }
  };

  // ── Filtragem e agrupamento ───────────────────────────────────────────────

  const ciclosFiltrados = searchOrdem.trim()
    ? ciclos.filter((c) =>
        (pecasPorCiclo[c.ciclo_key] ?? []).some((p) =>
          String(p.ordem).includes(searchOrdem.trim())
        )
      )
    : ciclos;

  useEffect(() => {
    if (searchOrdem.trim() && ciclosFiltrados.length === 1) {
      setExpandedRow(ciclosFiltrados[0].ciclo_key);
    }
  }, [searchOrdem, ciclosFiltrados.length]);

  const ciclosPorAba = {
    aguardando: ciclosFiltrados.filter(c => c.status?.toLowerCase().includes("aguardando")),
    "em-ciclo": ciclosFiltrados.filter(c => c.status?.toLowerCase().includes("em ciclo")),
    saida: ciclosFiltrados.filter(c =>
      c.status?.toLowerCase().includes("saida") || c.status?.toLowerCase().includes("saída")
    ),
  };

  // ── Renderização da tabela de ciclos (reutilizada por aba) ────────────────

  const renderCiclosTabela = (lista: Ciclo[]) => {
    if (lista.length === 0) {
      return (
        <div className="text-center py-4 text-muted fst-italic">
          Nenhum ciclo nesta categoria.
        </div>
      );
    }

    const grupos = groupByAutoclave(lista);

    return (
      <>
        {Object.entries(grupos).map(([autoclave, ciclosGrupo]) => (
          <div key={autoclave} className="mb-4">
            <div className="d-flex align-items-center gap-2 px-3 py-2 bg-light border-top border-bottom">
              <h6 className="fw-bold mb-0 text-secondary">{autoclave}</h6>
              <Badge bg="secondary" pill>{ciclosGrupo.length} ciclo(s)</Badge>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table className="table table-hover table-bordered mb-0 align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th className="fw-semibold">Ciclo-ISaga</th>
                    <th className="fw-semibold">Ciclo-SAP</th>
                    <th className="fw-semibold text-center">Checklist</th>
                    <th className="fw-semibold text-center">Válvulas</th>
                    <th className="fw-semibold">Carro</th>
                    <th className="fw-semibold">Tipo</th>
                    <th className="fw-semibold text-center">Status</th>
                    <th className="fw-semibold text-center">Peças</th>
                    <th className="fw-semibold text-center">Sets</th>
                    <th className="fw-semibold">Entrada</th>
                    <th className="fw-semibold">Entrada por</th>
                    <th className="fw-semibold">Saída</th>
                    <th className="fw-semibold">Saída por</th>
                    <th className="fw-semibold text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {ciclosGrupo.map((ciclo) => (
                    <React.Fragment key={ciclo.ciclo_key}>
                      <tr onClick={() => toggleRow(ciclo.ciclo_key)} style={{ cursor: "pointer" }}>
                        <td className="fw-semibold">{ciclo.ciclo_isaga}</td>
                        <td>{ciclo.ciclo_sap === 0 ? "—" : ciclo.ciclo_sap}</td>
                        <td>
                          <button
                            className="btn btn-info btn-sm"
                            disabled={ciclo.status?.toLowerCase().includes("aguardando entrada")}
                            onClick={(e) => { e.stopPropagation(); handelOpenACVCloseModalCheckList(ciclo.ciclo_key); }}
                          >
                            <Laptop fontSize="small" />
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn btn-info btn-sm"
                            disabled={ciclo.status?.toLowerCase().includes("aguardando entrada")}
                            onClick={(e) => abrirListaValvulas(e, ciclo)}
                          >
                            <Lock fontSize="small" />
                          </button>
                        </td>
                        <td>{ciclo.carro}</td>
                        <td>{ciclo.ciclo}</td>
                        <td>
                          <span className={`badge text-uppercase ${getStatusClass(ciclo.status)}`}>
                            {ciclo.status}
                          </span>
                        </td>
                        <td>
                          <Badge bg={contagemPecas[ciclo.ciclo_key] > 0 ? "primary" : "secondary"} pill>
                            {contagemPecas[ciclo.ciclo_key] || 0}
                          </Badge>
                        </td>
                        <td>
                          <Badge bg={contagemSets[ciclo.ciclo_key] > 0 ? "success" : "secondary"} pill>
                            {(contagemSets[ciclo.ciclo_key] || 0).toFixed(2)}
                          </Badge>
                        </td>
                        <td>
                          {ciclo.entrada
                            ? new Date(new Date(ciclo.entrada).getTime() - 3 * 60 * 60 * 1000).toLocaleString()
                            : "—"}
                        </td>
                        <td>{ciclo.entradaPor}</td>
                        <td>
                          {ciclo.saida
                            ? new Date(new Date(ciclo.saida).getTime() - 3 * 60 * 60 * 1000).toLocaleString()
                            : "—"}
                        </td>
                        <td>{ciclo.saidaPor}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <div className="d-flex gap-1 justify-content-center flex-wrap">
                            {ciclo.status?.toLowerCase().includes("aguardando entrada") && (
                              <>
                                <Button
                                  size="sm"
                                  variant="warning"
                                  onClick={() => { setCicloParaApontar(ciclo); setShowConfirmApontamento(true); }}
                                >
                                  Apontar
                                </Button>
                                <Button
                                  size="sm"
                                  variant="primary"
                                  onClick={() => { setCicloSelecionado(ciclo.ciclo_key); setModal(true); }}
                                >
                                  + Peça
                                </Button>
                                <Button
                                  size="sm"
                                  variant="secondary"
                                  onClick={() => abrirEditarAutoclave(ciclo)}
                                >
                                  Editar
                                </Button>
                                <Button
                                  size="sm"
                                  variant="danger"
                                  onClick={() => RemoverCiclo(ciclo.ciclo_key)}
                                >
                                  Excluir
                                </Button>
                              </>
                            )}
                            {ciclo.status?.toLowerCase().includes("em ciclo") && (
                              <Button
                                size="sm"
                                variant="warning"
                                onClick={() => { setCicloParaApontar(ciclo); setShowConfirmApontamento(true); }}
                              >
                                Apontar
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>

                      {/* Linha expandida com peças */}
                      {expandedRow === ciclo.ciclo_key && (
                        <tr>
                          <td colSpan={14}>
                            <div className="p-3 bg-light border rounded">

                              {/* Resumo por tipo de peça */}
                              {(pecasPorCiclo[ciclo.ciclo_key]?.length ?? 0) > 0 && (
                                <div className="mb-2 d-flex flex-wrap gap-2 align-items-center">
                                  <span className="fw-semibold text-secondary small me-1">Resumo:</span>
                                  {Object.entries(resumoPorTipo(pecasPorCiclo[ciclo.ciclo_key])).map(([tipo, qtd]) => (
                                    <Badge key={tipo} bg="info" text="dark" pill>
                                      {tipo} × {qtd}
                                    </Badge>
                                  ))}
                                </div>
                              )}

                              <h6 className="fw-bold mb-2">
                                Peças
                                <Badge bg="primary" className="ms-2" pill>
                                  {contagemPecas[ciclo.ciclo_key] || 0}
                                </Badge>
                                <Badge bg="success" className="ms-2" pill>
                                  {(contagemSets[ciclo.ciclo_key] || 0).toFixed(2)} sets
                                </Badge>
                              </h6>

                              {loadingPecas ? (
                                <div className="text-center py-2">
                                  <Spinner animation="border" size="sm" /> Carregando...
                                </div>
                              ) : (
                                <table className="table table-sm table-bordered w-100 text-center align-middle mb-0">
                                  <thead className="table-light">
                                    <tr>
                                      <th className="fw-semibold">Ordem</th>
                                      <th className="fw-semibold">Posição</th>
                                      <th className="fw-semibold">Piso</th>
                                      <th className="fw-semibold">Tipo Peça</th>
                                      <th className="fw-semibold">Cód. Veículo</th>
                                      <th className="fw-semibold">Projeto</th>
                                      <th className="fw-semibold">Veículo</th>
                                      <th className="fw-semibold">Qtd Sets</th>
                                      {ciclo.status?.toLowerCase().includes("aguardando entrada") && (
                                        <th className="fw-semibold">Ações</th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {pecasPorCiclo[ciclo.ciclo_key]?.length ? (
                                      pecasPorCiclo[ciclo.ciclo_key].map((p, i) => (
                                        <tr key={i}>
                                          <td>{p.ordem}</td>
                                          <td>{p.posicao}</td>
                                          <td>{p.piso ?? "—"}</td>
                                          <td>{p.tipoPeca}</td>
                                          <td>{p.codigoVeiculo}</td>
                                          <td>{p.projeto}</td>
                                          <td>{p.veiculo}</td>
                                          <td>
                                            <Badge bg="info" pill>
                                              {calcularQuantidadeSets(p.ordem_CC_RetMin || 0).toFixed(5)}
                                            </Badge>
                                          </td>
                                          {ciclo.status?.toLowerCase().includes("aguardando entrada") && (
                                            <td>
                                              <Button
                                                size="sm"
                                                variant="danger"
                                                onClick={() => handleRetiraPeca(p.ordem)}
                                              >
                                                Retirar
                                              </Button>
                                            </td>
                                          )}
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={ciclo.status?.toLowerCase().includes("aguardando entrada") ? 9 : 8}
                                          className="text-center text-muted fst-italic"
                                        >
                                          Nenhuma peça encontrada.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </>
    );
  };

  // ── JSX ───────────────────────────────────────────────────────────────────

  return (
    <div className="card shadow-sm border-0 rounded-lg">
      <div className="card-header d-flex justify-content-between align-items-center py-3 px-4 rounded-top">
        <h2 className="card-title h6 mb-0 fw-bold">📋 Lista de Ciclos</h2>
        <Button size="sm" variant="light" onClick={carregarCiclos} className="fw-bold px-3">
          Atualizar
        </Button>
      </div>

      <div className="px-4 pt-3 pb-2">
        <div className="d-flex align-items-center gap-2">
          <Form.Control
            type="text"
            placeholder="Buscar por Ordem..."
            value={searchOrdem}
            onChange={(e) => setSearchOrdem(e.target.value)}
            style={{ maxWidth: 250 }}
            size="sm"
          />
          {searchOrdem && (
            <Button variant="outline-secondary" size="sm" onClick={() => setSearchOrdem("")}>
              Limpar
            </Button>
          )}
        </div>
      </div>

      <div className="card-body p-3">
        {loadingCiclos ? (
          <div className="text-center py-5">
            <Spinner animation="border" size="sm" className="text-primary mb-2" />
            <p className="text-muted mt-2">Carregando ciclos...</p>
          </div>
        ) : (
          <Tabs
            activeKey={abaAtiva}
            onSelect={(k) => setAbaAtiva(k || "aguardando")}
            className="mb-3"
          >
            <Tab
              eventKey="aguardando"
              title={
                <span>
                  Aguardando Entrada{" "}
                  <Badge bg="warning" text="dark" pill>{ciclosPorAba.aguardando.length}</Badge>
                </span>
              }
            >
              {renderCiclosTabela(ciclosPorAba.aguardando)}
            </Tab>
            <Tab
              eventKey="em-ciclo"
              title={
                <span>
                  Em Ciclo{" "}
                  <Badge bg="primary" pill>{ciclosPorAba["em-ciclo"].length}</Badge>
                </span>
              }
            >
              {renderCiclosTabela(ciclosPorAba["em-ciclo"])}
            </Tab>
            <Tab
              eventKey="saida"
              title={
                <span>
                  Saída{" "}
                  <Badge bg="success" pill>{ciclosPorAba.saida.length}</Badge>
                </span>
              }
            >
              {renderCiclosTabela(ciclosPorAba.saida)}
            </Tab>
          </Tabs>
        )}
      </div>

      {/* ── Modais ─────────────────────────────────────────────────────────── */}

      <Modal show={modalChecklistACV} size="xl" onHide={handleACVCloseModalCheckList} centered>
        <Modal.Body>
          <ModalAcompanhamentoACV
            cicloSelecionando={cicloSelecionando}
            onClose={handleACVCloseModalCheckList}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showModalListaValvulas} onHide={() => setShowModalListaValvulas(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Perda de Vácuo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {valvulasFechadas.length === 0 ? (
            <p className="text-muted fst-italic">Nenhuma válvula cadastrada.</p>
          ) : (
            <table className="table table-striped table-bordered">
              <thead className="table-light">
                <tr>
                  <th className="fw-semibold">Ciclo</th>
                  <th className="fw-semibold">Autoclave</th>
                  <th className="fw-semibold">Linha</th>
                  <th className="fw-semibold">Válvula</th>
                  <th className="fw-semibold">Data</th>
                </tr>
              </thead>
              <tbody>
                {valvulasFechadas.map((v) => (
                  <tr key={v.valvulasFechadas_key}>
                    <td>{v.valvulasFechadas_ciclo}</td>
                    <td>{v.valvulasFechadas_autoclave}</td>
                    <td>{v.valvulasFechadas_linha}</td>
                    <td>{v.valvulasFechadas_valvula}</td>
                    <td>{new Date(v._ts_Creat).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalListaValvulas(false)}>Fechar</Button>
          <Button variant="primary" onClick={() => setShowModalCriarValvula(true)}>Fechar Válvula</Button>
        </Modal.Footer>
      </Modal>

      <ModalControleValvulasFechadas
        show={showModalCriarValvula}
        onHide={() => {
          setShowModalCriarValvula(false);
          carregarValvulas(cicloSelecionando?.ciclo_isaga);
        }}
        ciclo={cicloValvulas}
      />

      <Modal show={showEditAutoclave} onHide={() => setShowEditAutoclave(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Autoclave — Ciclo {editingCiclo?.ciclo_isaga}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => { e.preventDefault(); salvarAutoclave(); }}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Ciclo</Form.Label>
              <select
                className="form-select border-primary"
                value={editingCyclo}
                onChange={(e) => setEditingCyclo(e.target.value)}
                required
              >
                <option value="">Escolha o ciclo</option>
                <option value="CICLO PCHT N3">CICLO PCHT N3</option>
                <option value="CICLO PCHT IB33">CICLO PCHT IB33</option>
                <option value="CICLO AL NV7 NIMR">CICLO AL NV7 NIMR</option>
                <option value="CICLO KAROTEK PET">CICLO KAROTEK PET</option>
                <option value="CICLO KAROTEK NORTHGLASS">CICLO KAROTEK NORTHGLASS</option>
                <option value="CICLO PCHT N5 AGPB">CICLO PCHT N5 AGPB</option>
                <option value="CICLO AL NV5 COM AÇO">CICLO AL NV5 COM AÇO</option>
                <option value="CICLO NV8 PCHT AGPB">CICLO NV8 PCHT AGPB</option>
              </select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Autoclave</Form.Label>
              <Form.Select
                value={editingAutoclave}
                onChange={(e) => { setEditingAutoclave(e.target.value); setEditingCarro(""); }}
              >
                <option value="">Selecione</option>
                <option value="Chicago">Chicago</option>
                <option value="Matriz Molde">Matriz Molde</option>
                <option value="Ferlex">Ferlex</option>
                <option value="Fhaizer">Fhaizer</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Carro</Form.Label>
              <Form.Select
                value={editingCarro}
                onChange={(e) => setEditingCarro(e.target.value)}
                disabled={!editingAutoclave}
              >
                <option value="">Selecione</option>
                {carrosDisponiveis.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setShowEditAutoclave(false)}>Cancelar</Button>
          <Button variant="primary" size="sm" onClick={salvarAutoclave} disabled={loadingEditAutoclave}>
            {loadingEditAutoclave ? <Spinner animation="border" size="sm" /> : "Salvar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal principal — Adicionar Peças */}
      <Modal show={modal} onHide={fecharModal} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Apontamento da Peça
            {cicloSelecionado && (
              <span className="ms-2 text-muted fs-6 fw-normal">
                — {ciclos.find(c => c.ciclo_key === cicloSelecionado)?.autoclave}
              </span>
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="card p-3 shadow-sm rounded-3">
            <h6 className="fw-bold text-secondary mb-3">Adicionar Peças ao Ciclo</h6>

            {/* 5 campos de ordem */}
            <div className="row g-2 mb-4">
              {ordens.map((ordem, i) => (
                <div key={i} className="col-6 col-md-4">
                  <label className="form-label small fw-semibold">Ordem {i + 1}</label>
                  <Form.Control
                    type="text"
                    value={ordem}
                    ref={(el: HTMLInputElement | null) => { inputRefs.current[i] = el; }}
                    onChange={(e) => setOrdens(prev => prev.map((o, idx) => idx === i ? e.target.value : o))}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        if (i < 4) inputRefs.current[i + 1]?.focus();
                      }
                    }}
                    placeholder={`Ordem ${i + 1}`}
                  />
                </div>
              ))}
            </div>

            {/* Posição, Piso, Operador */}
            <div className="row g-3 align-items-start">
              <div className="col-12 col-md-4">
                <label className="form-label small fw-semibold">Posição</label>
                <div className="d-flex gap-2 flex-wrap mt-1">
                  {posicoes.map((pos, idx) => (
                    <Button
                      key={pos}
                      variant={peca.posicao === pos.toLowerCase() ? "primary" : "outline-primary"}
                      size="sm"
                      className="px-3"
                      onClick={(e) => { e.preventDefault(); setPeca((p) => ({ ...p, posicao: pos.toLowerCase() })); }}
                      onKeyDown={(e) => handlePosicaoKeyDown(e, idx)}
                    >
                      {pos}
                    </Button>
                  ))}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label small fw-semibold">Piso</label>
                <div className="d-flex gap-2 flex-wrap mt-1">
                  {pisos.map((n, idx) => (
                    <Button
                      key={n}
                      variant={peca.piso === n ? "primary" : "outline-primary"}
                      size="sm"
                      className="px-2"
                      onClick={(e) => { e.preventDefault(); setPeca((p) => ({ ...p, piso: n })); }}
                      onKeyDown={(e) => handlePisoKeyDown(e, idx)}
                    >
                      {n}
                    </Button>
                  ))}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label small fw-semibold">Operador</label>
                <Form.Select
                  size="sm"
                  value={peca.matricula || ""}
                  onChange={(e) => setPeca((p) => ({ ...p, matricula: e.target.value }))}
                >
                  <option value="">Selecione</option>
                  {operadores.map((op) => (
                    <option key={op.matricula} value={op.matricula}>
                      {op.matricula} - {op.nome}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={fecharModal}>
            Fechar
          </Button>
          <Button
            variant="primary"
            size="sm"
            disabled={ordens.every(o => !o.trim())}
            onClick={adicionarTodas}
          >
            Adicionar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmação de apontamento — matrícula coletada aqui */}
      <Modal show={showConfirmApontamento} onHide={fecharModalApontamento} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Apontamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            Apontar o ciclo <strong>{cicloParaApontar?.ciclo_isaga}</strong>?
          </p>
          <Form.Group>
            <Form.Label className="fw-semibold">Matrícula SAP</Form.Label>
            <Form.Control
              type="text"
              placeholder="Informe a matrícula SAP (mín. 6 caracteres)"
              value={matriculaApontamento}
              onChange={(e) => setMatriculaApontamento(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleConfirmApontamento(); }}
              minLength={6}
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={fecharModalApontamento}>
            Cancelar
          </Button>
          <Button
            variant="warning"
            size="sm"
            onClick={handleConfirmApontamento}
            disabled={loadingApontamento}
          >
            {loadingApontamento ? <Spinner animation="border" size="sm" /> : "Confirmar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
